import { FlexColumnDiv } from '@/app/shared/common.StyledComponents';
import styled from '@emotion/styled';
import { Card, rem } from '@triumph/design-system';

export const PaddedCard = styled(Card)<{ isLarge: boolean }>`
  padding: 0 ${({ isLarge }: any) => (isLarge ? `${rem(24)}` : `${rem(15)}`)}
    ${rem(12)};
  border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
  border-radius: ${rem(4)};
  box-shadow: none;
  position: relative;
  flex: 1;
  overflow: visible;
  max-width: 100%;
`;

export const DashboardContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(12)};
  align-items: flex-start;
  width: 100%;
  overflow: hidden;
`;

export const InvoicesTableContainer = styled.div`
  flex: 1;
  min-width: 0;
  max-width: calc(100% - ${rem(312)});
  overflow-y: visible;
`;

export const Sidebar = styled(FlexColumnDiv)`
  row-gap: ${rem(12)};
`;
